import { Box, styled } from "@mui/material";

// Wrapper component styling
export const Wrapper = styled(Box)(({ theme }) => ({
  width: `calc(100% - 80px)`,
  maxWidth: 1200,
  margin: "auto",
  padding: "16px",
  backgroundColor: theme.palette.background.paper,
  borderRadius: "8px",
  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
  [theme.breakpoints.down("md")]: {
    width: "100%",
    paddingLeft: "16px",
    paddingRight: "16px",
  },
}));

// PlanWrapper component styling
export const PlanWrapper = styled(Box)(({ theme }) => ({
  padding: "24px",
  backgroundColor: theme.palette.background.default,
  minHeight: "100vh",
}));

// LoadingContainer component styling
export const LoadingContainer = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "50vh",
});
